import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../action';
import * as c from '../constant';

function CreateModal({
  createInput,
  createInputNumber,
  createSelect,
  createPenalty,
  formData,
  history,
  getPenaltyList,
  ordinanceRevisionList,
  getOrdinanceRevisionList,
  getSinglePenalty,
}) {
  const setModal = useContext(ModalContext);

  useEffect(() => {
    getOrdinanceRevisionList();
  }, []);

  const handleOnSubmit = (e) => {
    e.preventDefault();
    const args = {
      ...formData,
      name: _.get(formData, 'name').replace(/\s+/g, ' ').trim(),
    };
    createPenalty(args, ({ data }) => {
      setModal({ isOpen: false });
      getPenaltyList();
      history.push(`/rpt/settings/penalties/${_.get(data, 'id')}`);
      getSinglePenalty(data.id);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const ordinanceRevisionOptions = ordinanceRevisionList.map((x) => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            {createInput(
              { key: 'name', label: 'Penalty Name:' },
              { required: true, type: 'text' }
            )}
          </div>
          <div className="col-12 form-group">
            {createInput(
              { key: 'description', label: 'Description:' },
              { required: true }
            )}
          </div>
          <div className="col-12 form-group">
            {createInputNumber(
              { key: 'surcharge', label: 'Monthly Penalty Percentage:' },
              { required: true }
            )}
          </div>
          <div className="col-12 form-group">
            {createInputNumber(
              { key: 'max_surcharge', label: 'Maximum Penalty Percentage:' },
              { required: true }
            )}
          </div>
          <div className="col-12 form-group">
            {createSelect(
              {
                required: true,
                placeholder: 'Select Ordinance Revision',
                key: 'ordinance_revision_id',
                label: 'Ordinance Revision:',
              },
              ordinanceRevisionOptions
            )}
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">Submit</span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CreateModal.propTypes = {
  createInput: PropTypes.instanceOf(Function).isRequired,
  createInputNumber: PropTypes.instanceOf(Function).isRequired,
  createSelect: PropTypes.instanceOf(Function).isRequired,
  getPenaltyList: PropTypes.instanceOf(Function).isRequired,
  createPenalty: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getSinglePenalty: PropTypes.instanceOf(Function).isRequired,
  getOrdinanceRevisionList: PropTypes.instanceOf(Function).isRequired,
  ordinanceRevisionList: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }) => ({
  ordinanceRevisionList: _.get(api, `${c.GET_ORDINANCE_REVISION}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(CreateModal);
